import { moveOrganizationalUnitError } from "@planzone/dto";
import { OrganizationalUnitsRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: OrganizationalUnitsRepository,
): Interactor {
  return ({ organizationalUnit, newParentUuid, insertAfterUuid }) =>
    present(
      repository
        .moveOrganizationalUnit(
          organizationalUnit,
          newParentUuid,
          insertAfterUuid,
        )
        .then(() => ({ organizationalUnit, newParentUuid, insertAfterUuid }))
        .catch((e) =>
          Promise.reject({
            organizationalUnit,
            newParentUuid,
            insertAfterUuid,
            error: { ...moveOrganizationalUnitError, ...e },
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
